<script lang="ts">
	import Router from 'svelte-spa-router'
	import Layout from './Components/Layout.svelte';
	import { routes } from './Routes/routes';
	import { Chart, registerables } from 'chart.js';
	import { onMount } from 'svelte';
	import ServerInfo from './Models/ServerInfo';
	import NoRestConnection from './Views/Status/NoRESTConnection.svelte';
	import Loading from './Views/Status/Loading.svelte';

	let errorDetails;
	let systemHealth = 'checking';

	const systemStatusWorker = setInterval(checkSystemStatus, 30000)

	function checkSystemStatus() {
		ServerInfo.get()
		.then(res => {
			if (res.status !== 200) systemHealth = 'error';
			else systemHealth = 'ok';
		})
		.catch(details => {
			errorDetails = details;
			systemHealth = 'error';
		})
	}

	onMount(checkSystemStatus)
	
	Chart.register(...registerables);
</script>

<Layout>
	{#if systemHealth == 'error'}
		<NoRestConnection {errorDetails} />
	{:else if systemHealth == 'ok'}
		<Router {routes} />
	{:else if systemHealth == 'checking'}
		<Loading />
	{/if}
</Layout>
